import React from "react";
import CountUp from "react-countup";
import { InfiosKeyFactsItem } from "./KeyFactsItem.style";
import Icon from "../../Icon/Icon";
import { colors } from "../../../utils/styled/_variables.styled";
import SlotCounter from "react-slot-counter";

const KeyFactsItem = (props) => {
	const {
		showIcon,
		endValue,
		decimals,
		suffix,
		prefix,
		subtitle,
		description,
		type,
		text,
		numberColor = "#8377D1",
		textColor = "#8377D1",
	} = props;

	const words = text ? text.split(" ") : undefined;

	return (
		<InfiosKeyFactsItem>
			{showIcon ? (
				<Icon
					icon="handshake"
					color={colors.lavender}
					className="handshake__icon"
				/>
			) : (
				<>
					{(!type || type === "number") && (
						<h2
							className="heading-1"
							style={{ color: numberColor || "inherit" }}
						>
							<CountUp
								decimals={decimals | 0}
								start={endValue > 10 ? 10 : 0}
								end={endValue}
								delay={0.3}
								scrollSpyDelay={300}
								enableScrollSpy={true}
								scrollSpyOnce={true}
								suffix={suffix || ""}
								prefix={prefix || ""}
								duration={3}
								redraw={true}
							/>
						</h2>
					)}
					{type === "text" && (
						<h2
							className="heading-1"
							style={{ color: numberColor || "inherit" }}
						>
							{words?.map((word, index) => (
								<>
									<SlotCounter
										startValue={""}
										value={word}
										animateOnVisible={{ triggerOnce: true }}
									/>
									{index !== words.length - 1 && <>&nbsp;</>}
								</>
							))}
						</h2>
					)}
				</>
			)}
			{subtitle && (
				<p className="lead" style={{ color: textColor || "inherit" }}>
					{subtitle}
				</p>
			)}
			{description && <div className="separator"></div>}
			{description && (
				<p
					className="keyfacts-text p-small"
					style={{ color: textColor || "inherit" }}
				>
					{description}
				</p>
			)}
		</InfiosKeyFactsItem>
	);
};

export default KeyFactsItem;
